import React from "react";
import { useLang } from "../lib/i18n";
import { ROLE_LABELS } from "../lib/ui";
import { History, Send, RotateCcw, BadgeCheck, Stamp, FilePlus2, Layers3 } from "lucide-react";

const ICONS = {
  generated: FilePlus2, submitted: Send, returned: RotateCcw,
  validated: BadgeCheck, consolidated: Stamp, provincial_consolidation: Layers3,
};
const TONES = {
  generated: "text-slate-400", submitted: "text-amber-600", returned: "text-red-600",
  validated: "text-emerald-600", consolidated: "text-[#0284C7]", provincial_consolidation: "text-[#0284C7]",
};

const fmt = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d) ? iso : d.toLocaleString();
};

export const ValidationTrail = ({ history }) => {
  const { t } = useLang();
  return (
    <section className="bg-white border border-[#E2E8F0] rounded-lg shadow-sm p-5 mb-4" data-testid="validation-trail">
      <h2 className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-1">
        <History className="h-4 w-4 text-slate-400" />{t("Historique de validation")}
      </h2>
      <p className="text-xs text-slate-500 mb-4">{t("Piste d'audit visible par le superviseur provincial et l'Administrateur.")}</p>
      {!history?.length ? (
        <p className="text-xs text-slate-400" data-testid="trail-empty">{t("Aucun événement enregistré pour ce rapport.")}</p>
      ) : (
        <ol className="relative border-l border-slate-200 pl-5 space-y-4">
          {history.map((h, i) => {
            const Icon = ICONS[h.action] || History;
            return (
              <li key={i} data-testid={`trail-item-${i}`}>
                <span className="absolute -left-[9px] flex h-[18px] w-[18px] items-center justify-center rounded-full bg-white border border-slate-200">
                  <Icon className={`h-3 w-3 ${TONES[h.action] || "text-slate-400"}`} />
                </span>
                <p className="text-sm font-semibold text-slate-800">{h.label || h.action}</p>
                <p className="text-xs text-slate-500">
                  {h.by || "-"}{h.role ? ` · ${t(ROLE_LABELS[h.role] || h.role)}` : ""} · {fmt(h.at)}
                </p>
                {h.detail && <p className="mt-0.5 text-xs text-slate-600 italic">{h.detail}</p>}
              </li>
            );
          })}
        </ol>
      )}
    </section>
  );
};
